import React from 'react';
import { FaUpload } from 'react-icons/fa';
import '../styles/Gallery.css';

const AdminGallery = () => (
  <div className="gallery-page">
    <h1>Gallery</h1>
    <p>Upload, edit, or remove images.</p>
    <button className="upload-btn"><FaUpload /> Upload Images</button>
    <div className="gallery-grid">
      {[1,2,3,4,5,6,7,8].map(i=>(<div className="gallery-card" key={i}><div className="gallery-placeholder">Image {i}</div><div className="gallery-actions"><button className="edit-btn">Edit</button><button className="delete-btn">Delete</button></div></div>))}
    </div>
  </div>
);
export default AdminGallery;
